import React from 'react'
import styled from '@emotion/styled'

import Button from '../../generic/button'
//import Phone from '../../../assets/phone.svg' put these in Orion and use from there
//import Globe from '../../../assets/countryoforigin.svg'
import { FlexDiv, FlexRowDiv } from '../../generic/Basics'
import { fontSize3XSmall, grayLight40, fontWeightSemibold, fontWeightBold, blueLight45, grayLight30 } from '../../../constants/principles'
import { useToggler } from '../../../hooks'
import Dealer from './Dealer'

export default ({ isDesktop, dealers, replacementVehicle, offerId, isCobrand, isAssigned, updateGlobalState, appointments, isAppointmentRequestEnabled, reserveOffer, hideDealerAddress }) => {
  const [toggleMoreDealers, setToggleMoreDealers] = useToggler(false)
  const yr = replacementVehicle.find(q => q.label === 'Year Range')
  const hasRv = replacementVehicle.find(question => question.label === 'LeadType').value === 'OptIn'
  const moreDealers = !isAssigned ? (hasRv ? dealers.buyingCenters : dealers.buyingCenters.concat(dealers.tradeInCenters)).sort((a, b) => a.distance - b.distance) : []
  const inventoryEntries = groupVehiclesByDealer(dealers.allocationEntries)

  return (
    <>
      {hasRv && (
        <>
          <RVTextDiv fontWeight={fontWeightBold}>Replacement Vehicle:</RVTextDiv>
          <RVBoxDiv>
            <RVInfoDiv>
              <RVTextDiv>
                {replacementVehicle
                  .find(q => q.questionId === 'qrv/LookingFor')
                  .subquestions.filter(i => i.value)
                  .map(i => i.label.split(' ')[0])
                  .join(', ')}
              </RVTextDiv>
              <RVTextDiv>{replacementVehicle.find(q => q.label === 'Make & Model').subquestions.find(q => q.questionId === 'qrv/MakeModel1').label}</RVTextDiv>
              <RVTextDiv>{yr && yr.min + ' - ' + yr.max} </RVTextDiv>
            </RVInfoDiv>
          </RVBoxDiv>
        </>
      )}
      <DealersDiv>
        {Array.from(inventoryEntries).map(([key, value], i) => (
          <Dealer
            dealer={dealers.allocationEntries.find(d => d.dealerInfo.dealerId === key).dealerInfo}
            key={i}
            vehicle={!isCobrand && replacementVehicle.find(question => question.label === 'LeadType').value === 'OptIn' && value}
            isAllocationEntrie
            {...{ appointments, isDesktop, offerId, updateGlobalState, isAppointmentRequestEnabled, hideDealerAddress, isAssigned }}
          />
        ))}
        {moreDealers.length > 0 && !reserveOffer && (
          <MoreButton
            data-testid={`oc-btn-see-more-dealers`}
            secondary={true}
            onClick={() => {
              setToggleMoreDealers()
              updateGlobalState({ fireAnalytics: `see_more_dealers` })
            }}>
            See More Participating Dealers
          </MoreButton>
        )}
        <MoreDealersDiv height={toggleMoreDealers ? 'auto' : '0px'}>
          {moreDealers.map((dealer, i) => (
            <Dealer dealer={dealer} appointments={appointments} key={i} isDesktop={isDesktop} offerId={offerId} updateGlobalState={updateGlobalState} isAppointmentRequestEnabled={isAppointmentRequestEnabled} hideDealerAddress={hideDealerAddress} />
          ))}
        </MoreDealersDiv>
      </DealersDiv>
    </>
  )
}

function groupVehiclesByDealer(allocationEntries) {
  const mapDealers = new Map()
  allocationEntries.forEach(item => {
    const key = item.dealerInfo.dealerId
    if (mapDealers.has(key)) {
      mapDealers.get(key).push(item.vehicleInfo)
    } else {
      mapDealers.set(key, [item.vehicleInfo])
    }
  })
  return mapDealers
}

const RVInfoDiv = styled(FlexDiv)`
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
`
const RVBoxDiv = styled(FlexRowDiv)`
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: ${blueLight45};
  max-width: 200px;
  margin: 16px auto;
  justify-content: flex-start;
  padding: 8px;
  border: 1px solid ${grayLight30};
  border-radius: 4px;
`
const RVTextDiv = styled.div`
  font-size: ${fontSize3XSmall};
  font-weight: ${p => (p.fontWeight ? p.fontWeight : fontWeightSemibold)};
`
const DealersDiv = styled.div`
  border-top: 1px solid ${grayLight40};
  width: 100%;
`
const MoreButton = styled(Button)`
  @media print {
    display: none;
  }
`
const MoreDealersDiv = styled.div`
  overflow: hidden;
  height: ${props => props.height};
`
